import React from 'react';
import { UserPostModel } from '../../NewsfeedModels';
import { Text } from 'library';

export default function ServiceOfferings({ user }: { user: UserPostModel }) {
    function prettyServiceOfferings(serviceOfferings: string[]) {
        let prettyServiceOfferings = '';
        if (serviceOfferings.length > 2) {
            prettyServiceOfferings = `${serviceOfferings[0]}, ${serviceOfferings[1]} and ${
                serviceOfferings.length - 2
            } others`;
        } else if (serviceOfferings.length === 2) {
            prettyServiceOfferings = `${serviceOfferings[0]} and ${serviceOfferings[1]}`;
        } else if (serviceOfferings.length === 1) {
            prettyServiceOfferings = serviceOfferings[0];
        }
        return prettyServiceOfferings;
    }

    let familyUser = user.role === 'FAMILY';

    return !user.service_offerings && !familyUser ? (
        <></>
    ) : (
        <Text variant="body3" bold>
            {familyUser ? 'Family' : prettyServiceOfferings(user?.service_offerings ?? [])}
        </Text>
    );
}
